import React from 'react'
import { Field, reduxForm } from 'redux-form'
import  validate  from './../validateReg';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import EmailField from '../EmailField';
import TextField from '../TextField';
import PasswordField from '../PasswordField';
import PhoneField from '../PhoneField';
import ProjectCodeField from '../ProjectCodeField';
import RenderCheckbox from '../AmLeader';
import Dropdown from '../Dropdown';

import { commonStyles } from '../../../styles/styles';

const FifthPage = ({ classes, form, pristine, previousPage, submitting, ...props }) => {
  const { handleSubmit, login } = props;
  
  return (
    <div className={classes.regFormWrapper}>
      <h4 className={classes.pageNo}>Page 4 of 5</h4>
      <form onSubmit={handleSubmit}>
      {login.error && <Typography className={classes.formError}>{login.error}</Typography>}
        <div className={`${classes.halfField}`}>
          <Field name="positionHeld" label="Position Held (Optional)" component={TextField}  />
        </div>
        <div className={`${classes.halfField} ${classes.firstInRow}`}>
          <Field name="businessUnit" label="Business Unit (Optional)" component={TextField}  />
        </div>
        <div className={classes.halfField}>
          <Field name="noYears" label="No. of years Employed (Optional)" component={TextField}  />
        </div>
        
        <div className="mt-2">
          <div className={classes.halfField}>
            <button variant="contained"
              className={`${classes.defaultButton} ${classes.shortButton}`} type="button"  onClick={previousPage}>Previous</button>
          </div>
          <div className={classes.halfField} style={{ flex: 1 }}>
          <button className={`${classes.defaultButton} ${classes.shortButton}`} type="submit" disabled={pristine || submitting}>Next</button>
          </div>
        </div>
      </form>
    </div>
  ) 
}



FifthPage.propTypes = {
  classes: PropTypes.instanceOf(Object),
  handleSubmit: PropTypes.func,
  login: PropTypes.instanceOf(Object),
  form: PropTypes.instanceOf(Object),
};

const mapStateToProps = state => ({
  form: state.form,
  login: state.loginReducer,
});
const mapDispatchToProps = dispatch => ({
  registrationRequest: () => dispatch(registrationRequest()),
  loginReset: () => dispatch(loginReset()),
});


const styles = () => ({
  ...commonStyles,
  halfField: {
    display: 'inline-flex',
    width: '49%',
  },
  firstInRow: {
    marginRight: '2%',
  },
  label: {
    color: '#e84848',
  },
  fullField: {
    width: '100%',
  },
  regFormWrapper: {
    maxWidth: '80%',
    margin: '0 auto',
  },
  rowWrapper: {
    display: 'flex',
  },
  noTopLabel: {
    paddingTop: 10,
    paddingLeft: 14,
  },
  pageNo:{
    textAlign: 'center',
    fontFamily: 'Roboto-Bold',

  }
});

export default compose(
  reduxForm({ form: 'registration',
  destroyOnUnmount: false,        // <------ preserve form data
  forceUnregisterOnUnmount: false,  // <------ unregister fields on unmount
  validate
 }),
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
)(FifthPage);



// WEBPACK FOOTER //
// ./src/Components/Form/RegistrationSteps/FifthPage.jsx